import { attr } from '@ember-data/model';
import ShModel from './sh-model';

const Pagination = ShModel.extend({
  total: attr('number'),
  count: attr('number'),
  perPage: attr('number'),
  currentPage: attr('number'),
  totalPages: attr('number')
});

export default Pagination;
